import { atom } from 'jotai';

const protectionModalCartItemIdAtom = atom(null);

export default protectionModalCartItemIdAtom;
